<template>
    <section class="component-ff7346f1" resmed-component-name="4card_icon-line_text_link"
        v-bind:style="{
            'background': acf.layout['background']
        }">
        <div class="component">
            <div class="container px-xs-sm-2">
                <div class="row">
                    <div class="col offset-md-1 offset-lg-2 offset-xl-0">
                        <eyebrow-icon v-if="acf.eyebrowicon" v-bind:eyebrowicon="acf.eyebrowicon"></eyebrow-icon>
                        <div class="title">
                            <h5 v-bind:class="[`text-color-${acf.layout['text-color']}`]">{{ acf.headline }}</h5>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="items">
                            <div class="item" v-for="(item, index) in acf.items">
                                <div class="card">
                                    <div class="mb-3 mb-md-0">
                                        <eyebrow-icon v-if="item.eyebrowicon" v-bind:eyebrowicon="item.eyebrowicon"></eyebrow-icon>
                                        <h4 v-html="item.title"></h4>
                                        <p v-if="item.description" v-html="item.description"></p>
                                    </div>

                                    <div class="call-to-action">
                                        <a v-bind:href="item.cta.href" v-bind:target="item.cta.target[0]" class="ctaButton cta-plain text-red icon right-arrow"">{{ item.cta.text }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "component-ff7346f1", // 4card_icon-line_text_link
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ff7346f1 {
  display: block;
}

.component {
  padding: 4rem 0;

  .title {
    text-align: center;
    margin-bottom: 0.5rem;
    @extend %body-normal-bold;

    @media (min-width: 768px) {
      text-align: left;
    }

    h5 {
      position: relative;
      margin-bottom: 0.25rem;
      color: $cc-resmed-white;

      &.text-color-black {
        color: $cc-resmed-black;

        &:before {
          background-color: $cc-resmed-black;
        }
      }

      @media (min-width: 768px) {
        margin-bottom: 0.75rem;
      }

      @extend %eyebrow-left;
      &:before {
        background-color: $cc-resmed-white;

        @media (max-width: 767px) {
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .items {
    margin: 0 -0.625rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      padding: 0.625rem;

      @media (max-width: 767px) {
        margin: 0 auto;
        flex-grow: 1;
      }

      @media (min-width: 768px) {
        width: calc(100% / 2);
        max-width: 302px;
      }

      @media (min-width: 992px) {
        max-width: 322px;
      }

      @media (min-width: 1200px) {
        width: calc(100% / 4);
      }

      h4 {
        position: relative;
        margin-bottom: 0.825rem;

        &:before {
          content: "";
          position: absolute;
          top: -1rem;
          width: 1.25rem;
          height: 3px;
          background-color: $cc-resmed-black;
        }
      }

      .card {
        display: flex;
        flex-direction: column;
        color: inherit;

        position: relative;
        background-color: $cc-resmed-white;
        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;

        margin: 0 auto;
        padding: 4rem 2rem 3rem 2rem;

        max-width: 360px;
        transition: all 0.5s;

        // &:hover {
        //     background-color: $cc-resmed-bg-grey-2;
        // }

        @media (min-width: 768px) {
          max-width: none;
          min-height: 260px;
        }

        @media (min-width: 1200px) {
          min-height: 260px;
        }

        .btn {
          position: absolute;
          bottom: 2rem;
        }
      }
    }
  }
}
</style>